import { bindContributionProvider } from "../../../common/contribution-provider";

import { EnvContribution } from "../../../constants";

export function bindEnvContributionModules({bind: bind}) {
    bindContributionProvider(bind, EnvContribution);
}

export default bindEnvContributionModules;
//# sourceMappingURL=modules.js.map
